import { render, staticRenderFns } from "./NwxSelect.vue?vue&type=template&id=5a007273&scoped=true"
import script from "./NwxSelect.vue?vue&type=script&lang=js"
export * from "./NwxSelect.vue?vue&type=script&lang=js"
import style0 from "./NwxSelect.vue?vue&type=style&index=0&id=5a007273&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a007273",
  null
  
)

export default component.exports